import React from "react";
import { salesSteps } from "./salesFeatureConstant";
import MarqueeCardScroller from "../../../Utility/MarqueeCardScroller";

const AutoScrollingRow: React.FC = () => {
  return <MarqueeCardScroller items={salesSteps} />;
};

export default AutoScrollingRow;
